import React, { useState, useEffect } from 'react';
import { Card, Button, Modal, Form, Alert, Spinner } from 'react-bootstrap';
import GerenciarHorariosFuncionario from './GerenciarHorariosFuncionario';
import Cookies from 'js-cookie';
import axios from 'axios';
import CardViewTable from '../../../components/CardViewTable/CardViewTable';
import { API_BASE_URL as API_BASE } from "../../../config";

function GerenciarFuncionarios() {
  const [funcionarios, setFuncionarios] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentFuncionario, setCurrentFuncionario] = useState(null);
  const [nome, setNome] = useState('');
  const [celular, setCelular] = useState('');
  const [senha, setSenha] = useState('');
  const [imagemUrl, setImagemUrl] = useState('');
  const [selectedServicos, setSelectedServicos] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [clienteMasterId, setClienteMasterId] = useState(null);
  const [showHorariosModal, setShowHorariosModal] = useState(false);
  const [funcionarioParaGerenciar, setFuncionarioParaGerenciar] = useState(null);

  useEffect(() => {
    const usuario = JSON.parse(Cookies.get("usuario") || '{}');
    if (usuario && usuario.role === "ClienteMaster") {
      setClienteMasterId(usuario.id);
      fetchData(usuario.id);
    } else {
      setError("Acesso negado. Você não é um cliente master.");
      setLoading(false);
    }
  }, []);

  const fetchData = async (masterId) => {
    setLoading(true);
    setError(null);
    try {
      const token = Cookies.get("authToken");
      const [funcResponse, servResponse] = await Promise.all([
        axios.get(`${API_BASE}/Funcionarios?idClienteMaster=${masterId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${API_BASE}/Servicos?idClienteMaster=${masterId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);
      setFuncionarios(funcResponse.data);
      setServicos(servResponse.data);
    } catch (err) {
      console.error("Erro ao buscar dados:", err);
      setError("Erro ao carregar funcionários ou serviços.");
    } finally {
      setLoading(false);
    }
  };

  const handleShowAddModal = () => {
    setIsEditing(false);
    setCurrentFuncionario(null);
    setNome('');
    setCelular('');
    setSenha('');
    setImagemUrl('');
    setSelectedServicos([]);
    setShowModal(true);
  };

  const handleShowEditModal = (funcionario) => {
    setIsEditing(true);
    setCurrentFuncionario(funcionario);
    setNome(funcionario.nome);
    setCelular(funcionario.celular);
    setSenha('');
    setImagemUrl(funcionario.imagemUrl || '');
    setSelectedServicos(funcionario.servicos.map(s => s.id));
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleShowHorariosModal = (funcionario) => {
    setFuncionarioParaGerenciar(funcionario);
    setShowHorariosModal(true);
  };

  const handleCloseHorariosModal = () => {
    setFuncionarioParaGerenciar(null);
    setShowHorariosModal(false);
  };

  const handleServicoChange = (servicoId) => {
    setSelectedServicos(prev =>
      prev.includes(servicoId)
        ? prev.filter(id => id !== servicoId)
        : [...prev, servicoId]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const token = Cookies.get("authToken");
      const celularDigits = celular.replace(/\D/g, ''); // Não adiciona 55

      const funcionarioData = {
        nome,
        celular: celularDigits,
        senha,
        imagemUrl,
        servicosIds: selectedServicos,
        dtInicioAlmoco: '', // Adicionado para evitar erro 400
        dtFimAlmoco: '', // Adicionado para evitar erro 400
        dtInicioAlmoco: '', // Adicionado para evitar erro 400
        dtFimAlmoco: '', // Adicionado para evitar erro 400
        clienteMasterId,
      };

      if (isEditing) {
        await axios.put(`${API_BASE}/Funcionarios/${currentFuncionario.id}`, funcionarioData, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        await axios.post(`${API_BASE}/Funcionarios`, funcionarioData, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      fetchData(clienteMasterId);
      handleCloseModal();
    } catch (err) {
      console.error("Erro ao salvar funcionário:", err);
      setError("Erro ao salvar funcionário.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async (funcionario) => {
    const confirm = await window.globalConfirm(`Tem certeza que deseja excluir o funcionário "${funcionario.nome}"?`);
    if (!confirm) return;

    setSubmitting(true);
    setError(null);
    try {
      const token = Cookies.get("authToken");
      await axios.delete(`${API_BASE}/Funcionarios/${funcionario.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchData(clienteMasterId);
      window.globalAlert('Funcionário excluído com sucesso!', 'success');
    } catch (err) {
      console.error("Erro ao excluir funcionário:", err);
      setError("Erro ao excluir funcionário.");
      window.globalAlert('Erro ao excluir funcionário.', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  const cardStyle = {
    backgroundColor: '#3c4049',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    padding: '25px',
    width: '100%',
    maxWidth: '100%',
    margin: '0',
  };

  return (
    <>
      <Card className="shadow-lg" style={cardStyle}>
        <Card.Title className="mb-4 fs-3 text-center">Gerenciar Funcionários</Card.Title>
        <Card.Body>
          <Button variant="primary" onClick={handleShowAddModal} className="mb-3">
            Adicionar Funcionário
          </Button>

          {funcionarios.length > 0 ? (
            <CardViewTable
              data={funcionarios}
              keyField="id"
              cardTitleKey="nome"
              columns={[
                { key: 'id', header: 'ID' },
                { key: 'nome', header: 'Nome' },
                { key: 'celular', header: 'Celular' },
                {
                  key: 'servicos',
                  header: 'Serviços',
                  render: (funcionario) => funcionario.servicos.map(s => s.nome).join(', '),
                },
                { key: 'actions', header: 'Ações' },
              ]}
              actions={(funcionario) => (
                <div className="d-flex flex-wrap gap-2">
                  <Button
                    variant="info"
                    size="sm"
                    onClick={() => handleShowEditModal(funcionario)}
                    className="flex-grow-1"
                  >
                    Editar
                  </Button>
                  <Button
                    variant="warning"
                    size="sm"
                    onClick={() => handleShowHorariosModal(funcionario)}
                    className="flex-grow-1"
                  >
                    Horários
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(funcionario)}
                    className="flex-grow-1"
                  >
                    Excluir
                  </Button>
                </div>
              )}
            />
          ) : (
            <Alert variant="info" className="text-center mb-0">
              Nenhum funcionário encontrado.
            </Alert>
          )}

          {/* Modal de Adicionar/Editar Funcionário */}
          <Modal show={showModal} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>{isEditing ? 'Editar Funcionário' : 'Adicionar Funcionário'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    type="text"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Celular (DDD + Número)</Form.Label>
                  <Form.Control
                    type="text"
                    value={celular}
                    onChange={(e) => {
                      let val = e.target.value.replace(/\D/g, '');
                      if (val.length > 11) val = val.slice(0, 11);
                      const masked = val
                        .replace(/^(\d{2})(\d{5})(\d{0,4})$/, '($1)$2-$3')
                        .replace(/-$/, '');
                      setCelular(masked);
                    }}
                    placeholder="(11)98765-4321"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Senha</Form.Label>
                  <Form.Control
                    type="password"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                  />
                  {!isEditing && (
                    <Form.Text className="text-muted">
                      A senha é obrigatória para novos funcionários.
                    </Form.Text>
                  )}
                  {isEditing && (
                    <Form.Text className="text-muted">
                      Deixe em branco para manter a senha atual.
                    </Form.Text>
                  )}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>URL da Imagem</Form.Label>
                  <Form.Control
                    type="text"
                    value={imagemUrl}
                    onChange={(e) => setImagemUrl(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Serviços</Form.Label>
                  {servicos.map(servico => (
                    <Form.Check
                      key={servico.id}
                      type="checkbox"
                      label={servico.nome}
                      checked={selectedServicos.includes(servico.id)}
                      onChange={() => handleServicoChange(servico.id)}
                    />
                  ))}
                </Form.Group>

                <div className="d-flex justify-content-end">
                  <Button variant="primary" type="submit" disabled={submitting}>
                    {submitting ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      'Salvar'
                    )}
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </Card.Body>
      </Card>

      {/* Modal de Gerenciamento de Horários */}
      {funcionarioParaGerenciar && (
        <GerenciarHorariosFuncionario
          funcionario={funcionarioParaGerenciar}
          show={showHorariosModal}
          handleClose={handleCloseHorariosModal}
        />
      )}
    </>
  );
}

export default GerenciarFuncionarios;